/**
 * <AseoCodeTag> — Tag visual del "Código de aseo" propio (#N = aseos.id).
 *
 * Hermano de <EstadiaCodeTag>. Muestra el identificador ÚNICO del aseo en sí
 * (su PK autoincremental), distinto del «Estadía #N» que vincula el aseo con su
 * arriendo. Color y ícono distintos a propósito, para que en una misma fila se
 * distingan de un vistazo:
 *   - «Aseo #N»    (purple, TagOutlined)  → identidad propia del aseo.
 *   - «Estadía #N» (geekblue, LinkOutlined) → arriendo vinculado.
 *
 * Fuente única del estilo del código de aseo. Ver utils/estadiaCode.ts y
 * docs/glosario.md. Devuelve `null` si `id == null` (no rompe el layout).
 */

import { Tag, Tooltip } from "antd";
import { TagOutlined } from "@ant-design/icons";
import { ASEO_SHORT, ASEO_TOOLTIP, formatEstadiaCode } from "../utils/estadiaCode";

interface AseoCodeTagProps {
  id?: number | string | null;
  /** Mostrar el tooltip explicativo. Default true. Usar false en celdas de tabla. */
  withTooltip?: boolean;
  /** Estilo extra opcional para el Tag. */
  style?: React.CSSProperties;
}

export default function AseoCodeTag({
  id,
  withTooltip = true,
  style,
}: AseoCodeTagProps) {
  if (id == null || id === "") return null;

  const tag = (
    <Tag
      color="purple"
      icon={<TagOutlined />}
      style={{ marginInlineEnd: 0, ...style }}
    >
      {ASEO_SHORT} {formatEstadiaCode(id)}
    </Tag>
  );

  return withTooltip ? <Tooltip title={ASEO_TOOLTIP}>{tag}</Tooltip> : tag;
}
